export const DOCUMENTS_LIST = [
  'Tersusunnya dokumen perencanaan, pemantauan, pembimbingan, evaluasi, dan pelaporan pendampingan satuan pendidikan nonformal',
]
